module.exports = __webpack_public_path__ + "static/media/info-blue.09ed07f8.svg";